import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';

import LogoLoader from 'components/Loader/LogoLoader';
import APIErrorMascot from 'components/Mascot/APIErrorMascot';
import Tabs, { TabHeader, TabPanels } from 'components/Tabs';
import { useFetchXeroOrganizationDetails } from 'hooks/integrations/xero/useFetchXeroOrganizationDetails';

import Employees from './EmployeeMapping';
import PayItem from './PayItemMapping';
import ProjectTasksMapping from './ProjectTasksMapping';
import ProjectUsersMapping from './ProjectUsersMapping';

const REGION = {
  AU: 'AU',
  US: 'US',
};

const MappingTabs = () => {
  const { t } = useTranslation(['common', 'integrations']);
  const [tabHeaders, setTabHeaders] = useState([
    { label: t('common:employees'), region: REGION.AU },
    { label: t('integrations:xero.payItem'), region: REGION.AU },
    { label: t('integrations:xero.xeroProjectUsers'), region: REGION.US },
    { label: t('integrations:xero.xeroProjectTasks'), region: REGION.US },
  ]);
  const [tabPanels, setTabPanels] = useState([
    { panel: <Employees />, region: REGION.AU },
    { panel: <PayItem />, region: REGION.AU },
    { panel: <ProjectUsersMapping />, region: REGION.US },
    { panel: <ProjectTasksMapping />, region: REGION.US },
  ]);

  const { data, status } = useFetchXeroOrganizationDetails();

  useEffect(() => {
    if (status === 'success') {
      const newTabHeaders = tabHeaders.filter(header => header.region === data?.payload?.region);
      const newTabPanels = tabPanels.filter(panel => panel.region === data?.payload?.region);
      setTabHeaders(newTabHeaders);
      setTabPanels(newTabPanels);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [status, data]);

  if (status === 'loading') return <LogoLoader />;
  if (status === 'error') return <APIErrorMascot />;

  return (
    <Tabs>
      <TabHeader tabHeaders={tabHeaders} />
      <TabPanels tabPanels={tabPanels} />
    </Tabs>
  );
};
export default MappingTabs;
